import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import appconst from "./../../lib/appconst";

interface PoReceiptState extends ListState<any> {
    lineList: Array<any>,
    lineTotalCount: number,
    lineCurrentPage: number,
    linePageSize: number,
    lineLoading: boolean,
}
class PoReceiptModule extends ListModule<PoReceiptState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        lineList: new Array<any>(),
        lineTotalCount:0,
        lineCurrentPage:1,
        linePageSize:10,
        lineLoading:false,
    }
    actions = {
        async getAll(context: ActionContext<PoReceiptState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/PoReceipt/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async get(context: ActionContext<PoReceiptState, any>, payload: any) {
            let reponse=await Ajax.get(`/api/services/app/PoReceipt/${payload.data.id}` );
            return reponse.data.result;
        },
        async getAllLines(
            context: ActionContext<PoReceiptState, any>,
            payload: any
          ) {
            context.state.lineLoading = true;
            const {
              data: { result },
            } = await Ajax.get(`/api/services/app/PoReceipt/${payload.data.id}/getAll-lines`, {
              params: payload.data,
            });
            context.state.lineLoading = false;
            const page = result as PageResult<any>;
            context.state.lineTotalCount = page.totalCount;
            context.state.lineList = page.items;
          },
          async export(context:ActionContext<PoReceiptState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}export/`+payload.data.id+`/po-receipt`, "_blank");    
        }
    };
    mutations = {
        
        setCurrentPage(state: PoReceiptState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PoReceiptState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setLineLoading(state: PoReceiptState, isLoading: boolean) {
            state.lineLoading = isLoading;
        },
        setLineCurrentPage(state: PoReceiptState, page: number) {
            state.lineCurrentPage = page;
        },
        setLinePageSize(state: PoReceiptState, pagesize: number) {
            state.linePageSize = pagesize;
        },
        setLineTotalCount(state: PoReceiptState, count: number) {
            state.lineTotalCount = count;
        },
        refreshListData(state: PoReceiptState)
        {
            state.list = new Array<any>();
        },
    }
}
const poReceiptModule = new PoReceiptModule();
export default poReceiptModule;